import React from "react";
import PropTypes from "prop-types";

function CompanyJobResult({ gid }) {
  return <div>CompanyJob: {JSON.stringify(gid)}</div>;
}

CompanyJobResult.propTypes = {
  gid: PropTypes.string.isRequired,
};

export default CompanyJobResult;
